export const FLIGHTS_NOT_FOUND_TITLE =
  "There are no flights available that match your filter criteria.";
export const FLIGHTS_NOT_FOUND_SUBTITLE =
  "Clear filters to view more flights on this route, or change your dates.";
export const CLEAR_FILTERS_CTA_TEXT = "Clear all filters";
